import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ApprovalOrderItem from './ApprovalOrderItem';
import styles from './ApprovalOrder.module.scss';

interface Approver {
  id: string;
  email: string;
  fullName: string;
  order?: number;
}

interface ApprovalOrderListProps {
  approvers: Approver[];
  onReorder: (reorderedApprovers: Approver[]) => void;
  isDisabled?: boolean;
}

const ApprovalOrderList: React.FC<ApprovalOrderListProps> = ({ approvers, onReorder, isDisabled = false }) => {
  const moveItem = (dragIndex: number, hoverIndex: number) => {
    const reordered = [...approvers];
    const [draggedItem] = reordered.splice(dragIndex, 1);
    reordered.splice(hoverIndex, 0, draggedItem);

    // Update order numbers
    const withNewOrder = reordered.map((approver, index) => ({
      ...approver,
      order: index,
    }));

    onReorder(withNewOrder);
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div className={styles.approvalOrderList}>
        <div className={styles.listHeader}>
          <strong>Approval Order:</strong>
          <span className={styles.helperText}>Drag to reorder</span>
        </div>
        <div className={styles.listContainer}>
          {approvers.map((approver, index) => (
            <ApprovalOrderItem
              key={approver.id}
              index={index}
              id={approver.id}
              order={index + 1}
              name={approver.fullName}
              email={approver.email}
              moveItem={moveItem}
              isDisabled={isDisabled}
            />
          ))}
        </div>
      </div>
    </DndProvider>
  );
};

export default ApprovalOrderList;
